import { BaseSystem, system } from 'aframe-typescript-class-components'

@system('controls')
export class ControlsSystem extends BaseSystem {
  init(): void {
    
  }
}